import React from 'react';
import { useTranslation, Trans } from "react-i18next";
import './FacialInstructions.sass';


import { Box } from '@mui/material';
import { IoCameraOutline } from "react-icons/io5";
import { FiUser } from "react-icons/fi";
import { FiCheckCircle } from "react-icons/fi";
import { SlFrame } from "react-icons/sl";
import { GoClock } from "react-icons/go";
import { BASE } from '../../basedata/constants'
import { useLocation } from 'react-router-dom'
import Illustration from '../Illustration/Illustration'

interface Props {
  handleCloseInstructions: () => void;
  isVerse?: boolean;
  children?: React.ReactNode;
  togglePanel: () => void;
  hideFrameImage?: boolean;
}


// well, sthepany needs to work on this
const WaIoCameraOutline = IoCameraOutline as React.ComponentType<React.SVGProps<SVGSVGElement>>;
const WaFiCheckCircle = FiCheckCircle  as React.ComponentType<React.SVGProps<SVGSVGElement>>;
const WaSlFrame = SlFrame  as React.ComponentType<React.SVGProps<SVGSVGElement>>;
const WaGoClock = GoClock  as React.ComponentType<React.SVGProps<SVGSVGElement>>;
const WaFiUser = FiUser  as React.ComponentType<React.SVGProps<SVGSVGElement>>;

const DocumentInstructions = ({
  handleCloseInstructions,
  isVerse = false,
  children,
  togglePanel,
  hideFrameImage
}: Props) => {
  const { t } = useTranslation();
  const location = useLocation();

  const isPage = location.pathname.includes('/instructions-document');

  
  return (
    <div className="instructions-content">
      <h1 className="instructions-content-title">
        {isVerse ? t("capture_document.verse_header_title"):t("capture_face.title")}
      </h1>
      {!hideFrameImage && (
        <Illustration
          src={isVerse ? "./ilustra-doc-verso.png" : "./ilustra-doc-frente.png"}
          alt={t("capture_document.instructions")}
        />
      )}

      <ul>
        <li className="instruction-item">
          <span className="number-instruction"><WaFiUser /></span>
          <div className="instruction-content">
            <p className="instruction-title">{t("step.validate_document")}</p>
            <p className="instruction-text">
              <Trans
                i18nKey={
                  isVerse
                    ? "capture_document.tips.tip_1_verse"
                    : "capture_document.tips.tip_1"
                }
                components={{ bold: <strong /> }}
              />
            </p>
          </div>
        </li>
        <li className="instruction-item">
          <span className="number-instruction"><WaFiCheckCircle /></span>
          <div className="instruction-content">
            <p className="instruction-title">{t("step.prepare_surface")}</p>
            <p className="instruction-text">
              <Trans i18nKey="capture_document.tips.tip_2" components={{ bold: <strong /> }} />
            </p>
          </div>
        </li>
        <li className="instruction-item">
          <span className="number-instruction"><WaSlFrame /></span>
          <div className="instruction-content">
            <p className="instruction-title">{t("step.center_frame")}</p>
            <p className="instruction-text">
              <Trans i18nKey="capture_document.tips.tip_3" components={{ bold: <strong /> }} />
            </p>
          </div>
        </li>
        <li className="instruction-item">
          <span className="number-instruction"><WaGoClock /></span>
          <div className="instruction-content">
            <p className="instruction-title">{t("step.capture")}</p>
            <p className="instruction-text">
              <Trans i18nKey="capture_document.tips.tip_4" components={{ bold: <strong /> }} />
            </p>
          </div>
        </li>
      </ul>
      {window.location.pathname.includes('/instructions-document') && (
          <div className="button-container">
            <button
              className="retry-button"
              onClick={() => {
                document.querySelector('.instructions-content')?.scrollTo({ top: 0, behavior: 'smooth' });
                handleCloseInstructions();
              }}
            >
              <span className="camera-wrapper">
                <WaIoCameraOutline />
                {t("capture_document.buttons.retry_photo")}
              </span>
            </button>
          </div>
        )}
        {!isPage && (
          <footer className="footer-instructions">
            <img 
              src={ BASE.company.bepassMobileLogo}  
              alt={BASE.company.name}
              className="footer-logo"
            />
          </footer>
        )}
    </div>
  );
};

export default DocumentInstructions;
